import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import Footer from './components/Footer';
import Header from './components/Header';
import { HelmetProvider } from "react-helmet-async";
import { routes } from "./routes";
import Meta from "./Meta";
import TagManager from 'react-gtm-module';



// Google Tag Manager
const tagManagerArgs = {
  gtmId: 'GTM-PSDHQZL' 
};


const AppContainer = styled.div`
  min-height: 100vh;
  font-family: 'Noto Sans JP', sans-serif;
`;

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');
  
  :root {
    --contents-maxwidth-pc: 1280px;
  }


  * {
    box-sizing: border-box;
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: 'Noto Sans JP', sans-serif;
    line-height: 1.6;
    background-color: #F9FAFA;
  }

  @media (max-width: 768px) {
    .pc-only { display: none; }
  }
  @media (min-width: 769px) {
    .sp-only { display: none; }
  }
`;

function App() {
  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <HelmetProvider>
    <Router basename={process.env.REACT_APP_BASENAME || '/'}>
      <GlobalStyles />
      <AppContainer>
        <Header />
        <Routes>
            {routes.map(({ path, element, meta }) => (
              <Route
                key={path}
                path={path}
                element = {
                  <>
                    <Meta {...meta} />
                    {element}
                    { path !== '/' && <Footer /> }
                  </>
                }
              />
            ))}
        </Routes>
      </AppContainer>
    </Router>
    </HelmetProvider>
  );
}

export default App;
